module.exports = __webpack_public_path__ + "media/src/images/step06-cbb7622f5d0a5f159931f4debec4d8e0.png";